import { render, staticRenderFns } from "./buyer_report.vue?vue&type=template&id=234a23b0"
import script from "./buyer_report.vue?vue&type=script&lang=js"
export * from "./buyer_report.vue?vue&type=script&lang=js"
import style0 from "./buyer_report.vue?vue&type=style&index=0&id=234a23b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports